import React from 'react'
import PropTypes from 'prop-types'

import { Image, Motion, Text, Wrapper } from 'Components/UI'

import {
  Container,
  Content,
  Description,
  ImageWrapper,
  PrimaryImageBg,
  PrimaryImageHolder,
  SecondaryImageHolder,
} from './styles'

function Feature({ data, index }) {
  const reverse = index % 2
  return (
    <Container>
      <Wrapper flexDirection="column">
        <Motion width={1}>
          <Content
            flexDirection={
              !reverse
                ? ['column', 'column', 'column', 'row']
                : ['column', 'column', 'column', 'row-reverse']
            }
            mt={[32, 32, 64, 0]}
          >
            {data?.primaryImage && (
              <ImageWrapper
                ml={reverse ? [0, 0, 32, 104] : 0}
                mr={!reverse ? [0, 0, 32, 104] : 0}
              >
                <PrimaryImageBg reverse={reverse ? 1 : 0} />

                <PrimaryImageHolder>
                  <Image
                    alt=""
                    image={data?.primaryImage}
                    lazy
                    sizes="(max-width: 524px) 100vw, 524px"
                  />
                </PrimaryImageHolder>
              </ImageWrapper>
            )}
            <Description mt={[32, 32, 48, 0]}>
              <Text as="h2" fontSize={[20, 48]} lineHeight={1} medium>
                {data?.title}
              </Text>

              <Text justify light markdown mt={[8, 16, 24, 42]}>
                {data?.text}
              </Text>
            </Description>
          </Content>
        </Motion>

        {data?.secondaryImage && (
          <SecondaryImageHolder mt={[32, 32, 32, 96]}>
            <Image
              alt=""
              image={data?.secondaryImage}
              lazy
              sizes="(max-width: 524px) 100vw, 524px"
            />
          </SecondaryImageHolder>
        )}
      </Wrapper>
    </Container>
  )
}

Feature.defaultProps = {
  data: {},
  index: 0,
}

Feature.propTypes = {
  data: PropTypes.object,
  index: PropTypes.number,
}

export default Feature
